import { render, staticRenderFns } from "./ImageTable.vue?vue&type=template&id=718c0d8a&scoped=true&"
import script from "./imagetable.js?vue&type=script&lang=js&"
export * from "./imagetable.js?vue&type=script&lang=js&"
import style0 from "./ImageTable.vue?vue&type=style&index=0&id=718c0d8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718c0d8a",
  null
  
)

export default component.exports